export default '/pricing/one-price';
